"use client";
import { useEffect } from "react";
import { useSessionStore } from "@/lib/sessionStore";

// This mounts inside any lesson page — starts counting active time
export default function LessonTimer() {
  const { isInLesson, isOnBreak, tickActiveSecond, breakSettings, lessonSecondsActive } =
    useSessionStore();

  useEffect(() => {
    if (!isInLesson || isOnBreak) return;
    const interval = setInterval(tickActiveSecond, 1000);
    return () => clearInterval(interval);
  }, [isInLesson, isOnBreak, tickActiveSecond]);

  if (!isInLesson) return null;

  const workSecs = breakSettings.workMinutes * 60;
  const remaining = workSecs - lessonSecondsActive;
  const mins = Math.floor(remaining / 60);
  const progress = lessonSecondsActive / workSecs;

  return (
    <div className="fixed top-4 right-4 z-40 bg-black/70 rounded-xl px-4 py-2 flex items-center gap-3">
      <div className="text-xs text-gray-400">休息前</div>
      <div className="text-white font-mono font-bold">{mins}分</div>
      <div className="w-16 bg-gray-700 rounded-full h-1.5">
        <div
          className="bg-green-400 h-1.5 rounded-full transition-all"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  );
}
